<script lang="ts">
  import { GitCommitVertical } from '@lucide/svelte'
  import i18n from '../../../i18n'
  import { sceneMode } from '../../../stores/scene-mode'
  import {
    canvasSelection,
    canvasMultiSelection,
  } from '../../../stores/canvas-selection'
  import useObjectQueries from '../../../routes/project/hooks/useObjectQueries'
  import useCanvasSelection from '../../../hooks/canvas-selection'
  import Button from '../../button/Button.svelte'
  import Tooltip from '../../tooltip/Tooltip.svelte'

  const { useObject } = useObjectQueries()
  const { hasSingleFile, hasSingleSoloGroup } = useCanvasSelection()

  // Seam placement targets a single selected, visible file - so the toolbar
  // entry point must reflect the same requirement the click handler enforces.
  // A solo group (a group holding exactly one file) counts as that file: it's
  // presented in the left bar as if there were no group at all.
  const selectedFileQuery = $derived(useObject($canvasSelection?.uuid))
  const canPlaceSeam = $derived(
    !!$canvasSelection
      && (hasSingleFile() || hasSingleSoloGroup())
      && !$canvasMultiSelection.length
      && !!selectedFileQuery.data?.visible,
  )

  $effect(() => {
    if (!canPlaceSeam && $sceneMode === 'seam') {
      sceneMode.set('default')
    }
  })

  function onClick() {
    sceneMode.set('seam')
  }
</script>

<Tooltip placement="top" title={$i18n.t('project.modes.seam')}>
  <Button
    size="icon-sm"
    disabled={!canPlaceSeam}
    variant={$sceneMode === 'seam' ? 'default' : 'ghost'}
    onclick={onClick}
  >
    <GitCommitVertical />
  </Button>
</Tooltip>
